import React, { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';

const MarketParamContext = createContext('');
const RequestIdParamContext = createContext('');
const CameraParamContext = createContext('');
const EimParamContext = createContext('');

interface IUrlParamsContextProvider {
  children?: React.ReactNode;
}

export const UrlParamsProvider: React.FC<IUrlParamsContextProvider> = (props) => {
  const params = useParams();
  return (
    <MarketParamContext.Provider value={params.market || ''}>
      <RequestIdParamContext.Provider value={params.requestId || ''}>
        <EimParamContext.Provider value={params.eim || ''}>
          <CameraParamContext.Provider value={params.camera || ''}>
            {props.children}
          </CameraParamContext.Provider>
        </EimParamContext.Provider>
      </RequestIdParamContext.Provider>
    </MarketParamContext.Provider>
  );
};

export const useMarketParam = () => useContext(MarketParamContext);
export const useRequestIdParam = () => useContext(RequestIdParamContext);
export const useCameraParam = () => useContext(CameraParamContext);
export const useEimParam = () => useContext(EimParamContext);
